<!--
  Single grid container — ordering of sub-components in the consumer's
  template is irrelevant; element-name `<ng-content select="...">` projection
  routes each sub-component into its named grid area.

  The selectors target the sub-component custom element directly. The grid
  template areas (defined in SCSS) enforce the canonical visual order:
  breadcrumbs (lead) → title → subtitle → actions → tabs.
-->
<!--
  Breadcrumb lead band. The header renders its OWN `auto` breadcrumb by
  default (opt-out via `[breadcrumb]="false"`), so no page needs to declare
  the element. If the page DOES project its own `<tw-page-header-breadcrumbs>`
  (items mode / a variant override / projected content), that projected one is
  used via the <ng-content> below and the auto one is suppressed — projected
  wins, never a double crumb. Both land in the `breadcrumbs` grid-area via the
  `.tw-page-header > tw-page-header-breadcrumbs` rule (ViewEncapsulation.None).
-->
<!--
  F19 Wave 7 — the contributed breadcrumb segment now renders INLINE inside the
  breadcrumb trail (the auto-walked `<tw-page-header-breadcrumbs>`) as its
  trailing item, NOT on a separate grid row below. The `[slot=breadcrumb-segment]`
  content the consumer contributes is projected into the auto breadcrumbs'
  `[breadcrumb-trailing]` slot — so the rich version switcher trails the last
  crumb on the SAME line (`… › Configuration › [switcher]`). It collapses to
  nothing when no segment is contributed (installations etc. unaffected).
-->
@if (renderAutoBreadcrumb()) {
  <tw-page-header-breadcrumbs auto>
    <span breadcrumb-trailing>
      <ng-content select="[slot=breadcrumb-segment]"></ng-content>
    </span>
  </tw-page-header-breadcrumbs>
}
<ng-content select="tw-page-header-breadcrumbs"></ng-content>
<ng-content select="tw-page-header-title"></ng-content>
<ng-content select="tw-page-header-subtitle"></ng-content>
<ng-content select="tw-page-header-actions"></ng-content>
<ng-content select="tw-page-header-tabs"></ng-content>
